import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers/reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const templatesSlice = createAppSlice({
  name: 'templates',
  initialState,
  reducers,
});

export const {
  fetchThemePacks,
  saveThemePack,
  createThemePack,
  fetchThemesAndTemplates,
  fetchUserTemplateFavorites,
  deleteUserTemplateFavorite,
  addUserTemplateFavorite,
  updateRefetchTemplatesCounter,
  clearTemplatesList,
  appendNewTheme,
  setThemePack,
  fetchFontPacks,
  setFontPack,
  appendFontPacks,
  deleteThemePackSync,
  fetchAllGlobalTemplatesForCategories,
  fetchTemplateCategories,
  createNewTemplateCategory,
  deleteTemplateCategory,
  replaceTemplatesForCategory,
} = templatesSlice.actions;

export default templatesSlice.reducer;
